import peopleSvg from '../../../../assets/images/icons/people.svg'
import starSvg from '../../../../assets/images/icons/star.svg'
import usdSvg from '../../../../assets/images/icons/usd.svg'
import { ECurrency } from '../../../../types/enums'

export const lobbyTabs: Partial<
  Record<
    | typeof ECurrency.TON
    | typeof ECurrency.USDT
    | typeof ECurrency.COIN
    | 'connectToPrivateTable',
    React.ReactNode
  >
> = {
  [ECurrency.TON]: (
    <>
      <img
        src={usdSvg}
        alt=''
      />
      <span>TON</span>
    </>
  ),
  // [ECurrency.USDT]: (
  //   <>
  //     <img
  //       src={usdSvg}
  //       alt=''
  //     />
  //     <span>USDT</span>
  //   </>
  // ),
  [ECurrency.COIN]: (
    <>
      <img
        src={starSvg}
        alt=''
      />
      <span>Free</span>
    </>
  ),
  // [ECurrency.TOKEN]: 'Token',
  connectToPrivateTable: (
    <>
      <img
        src={peopleSvg}
        alt=''
      />
      <span>Private</span>
    </>
  ),
}
